import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SwiperClass from 'swiper/types/swiper-class';

const preventPageScroll = (event: KeyboardEvent) => {
  if (event.key === ' ') {
    event.preventDefault();
  }
};

const resetClippedScroll = ({ currentTarget }: FocusEvent) => {
  for (
    let ancestor = (currentTarget as Element).parentElement;
    ancestor;
    ancestor = ancestor.parentElement
  ) {
    if (
      ancestor.scrollLeft &&
      getComputedStyle(ancestor === document.scrollingElement ? document.body : ancestor)
        .overflowX === 'hidden'
    ) {
      ancestor.scrollLeft = 0;
    }
  }
};

export const useSwiperA11y = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      a11y: {
        prevSlideMessage: t('common.previous-slide'),
        nextSlideMessage: t('common.next-slide'),
        firstSlideMessage: t('common.first-slide'),
        lastSlideMessage: t('common.last-slide'),
      },
      onAfterInit: ({ el, navigation }: SwiperClass) => {
        el.addEventListener('focusin', resetClippedScroll);
        [navigation?.prevEl, navigation?.nextEl].forEach((element) =>
          element?.addEventListener('keydown', preventPageScroll)
        );
      },
    }),
    [t]
  );
};
